import React, { useMemo } from 'react';

import Button from 'components/shared/Button';
import Divider from 'components/shared/Divider';
import Plus from 'components/shared/Icon/icons/Plus';
import Search from 'components/shared/Icon/icons/Search';
import Text from 'components/shared/Typography/Text';

import ActionsMenu from '../../../Itinerary/Details/ActionsMenu';
import { IAction } from '../../../Itinerary/Details/ActionsMenu/types';
import s from './index.module.css';

export function AddNewGuest({
  onShowGuestForm,
  onShowSearchForm,
  btnText,
}: {
  onShowGuestForm: () => void;
  onShowSearchForm: () => void;
  btnText: string;
}) {
  const actions = useMemo<IAction[]>(() => {
    return [
      {
        title: 'Create New Guest',
        onClick: onShowGuestForm,
        icon: Plus,
      },
      {
        title: 'Search Existing',
        onClick: onShowSearchForm,
        icon: Search,
      },
    ];
  }, [onShowGuestForm, onShowSearchForm]);

  return (
    <div className={s.wrapper}>
      <div className={s.addNewBtn}>
        <ActionsMenu
          actions={actions}
          className={s.actionsMenu}
          optionsClassName={s.option}
          customLayerStyles={{ zIndex: 1, marginTop: '0px' }}
        >
          <Button htmlType="button" size="large">
            {btnText}
          </Button>
        </ActionsMenu>

        <Text italic accent className={s.addNewDesc}>
          Click button to add a new guest form.
        </Text>
      </div>
      <Divider isMarginSm />
    </div>
  );
}
